import { SolanaIcon } from '../icons/solana';
import { UsdcIcon } from '../icons/usdc';

import { token } from '@/constants/solana';
import { useFetchTokenBalance } from '@/hooks/solana/query/use-fetch-token-balance';
import { useSolanaBalance } from '@/hooks/solana/query/use-solana-balance';

export const WalletBalance = () => {
  const { data: tokenBalance } = useFetchTokenBalance(token);
  const { data: solanaBalance } = useSolanaBalance();

  return (
    <div className="flex flex-row justify-end gap-2 text-[11px]">
      <div className="text-secondary-light-gray">Wallet balance</div>
      <div className="flex items-center gap-1">
        <p>{tokenBalance?.uiAmount ? tokenBalance.uiAmount.toFixed(2) : 0}</p>
        <UsdcIcon />
      </div>
      <div className="flex items-center gap-1">
        <p>{solanaBalance?.uiAmount ? solanaBalance.uiAmount.toFixed(3) : 0}</p>
        <SolanaIcon />
      </div>
    </div>
  );
};
